export enum StudentMentorRequestStatus{
    Pending,
    Approved,
    Rejected
}

export const StudentMentorRequestStatusDescription: { [key in StudentMentorRequestStatus | any]: string} = {
    [StudentMentorRequestStatus.Pending]: "Pending",
    [StudentMentorRequestStatus.Approved]: "Approved",
    [StudentMentorRequestStatus.Rejected]: "Rejected"
}